export const PORTAL_MODULE = 'portal'

export function getModuleNameFromSubdomain(subdomain) {
    const moduleName = subdomain?.split('.')[1]

    if (!moduleName || moduleName.includes('znaptech')) return PORTAL_MODULE

    return moduleName
}

export default function getModuleUrl(moduleName) {
    const modulePath = moduleName === PORTAL_MODULE ? '' : `${moduleName}/`

    return `${window.location.origin}/${modulePath}`
}
